<div class="narrowed-container">
  <div class="row">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h1 class="content-pages-single-title my-6 text-3xl font-bold text-grey-1 md:text-4xl">{{ h1Title() }}</h1>
      <div *ngIf="introText() && introText() !== ''" class="text-base mb-4">{{ introText() }}</div>
      <ul class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <li *ngFor="let item of categoryItems()">
          <a [routerLink]="item.routerLink" [title]="item.title" class="mr-2">{{ item.name }}</a>
          <a [routerLink]="item.moreRouterLink" [title]="item.moreTitle" class="inline-block">
            <div class="flex justify-center items-center rounded bg-duck-blue-10 px-2 py-1 w-fit align-baseline">
              <app-ui-icon class="align-middle" color="var(--duck-blue-2)" name="chevron_right" size="sm"></app-ui-icon>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="col-s">
      <app-sidebar
        [isAdVisible]="true"
        [pageType]="pageType"
      ></app-sidebar>
    </div>
  </div>
</div>
